import { render, staticRenderFns } from "./KCard.vue?vue&type=template&id=65ebb91e&scoped=true&lang=html&"
var script = {}
import style0 from "./KCard.vue?vue&type=style&index=0&id=65ebb91e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ebb91e",
  null
  
)

export default component.exports